export default "{\n    \"errors\": {\n        \"copyFailed\": \"No se pudo copiar al portapapeles\"\n    }\n}\n"